import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function PullQuote() {
  return <section className="w-full py-12 px-4" data-id="element-158">
      <div className="max-w-2xl mx-auto" data-id="element-159">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative text-center py-8" data-id="element-160">
          <Quote className="absolute top-0 left-1/2 -translate-x-1/2 w-16 h-16 text-brown/15 rotate-180" data-id="element-161" />

          <p className="font-serif text-2xl md:text-3xl text-gray-800 italic leading-relaxed relative z-10 px-8" data-id="element-162">
            "Ich wollte einfach nur, dass es Finn wieder gut geht."
          </p>
        </motion.div>
      </div>
    </section>;
}